<template>
    <div>
        <section class="calendar-section">
            <div class="container-limit">
                <h2 class="calendar-title text-start mb-10">Calendário:</h2>

                <v-row align="center" justify="space-between" class="calendar-header mb-6">
                    <v-col cols="12" md="10" class="d-flex align-center">
                        <v-btn outlined color="primary" class="mr-4" @click="goToday">Hoje</v-btn>

                        <v-btn icon @click="changeMonth(-1)">
                            <v-icon color="primary">mdi-chevron-left</v-icon>
                        </v-btn>

                        <v-btn icon @click="changeMonth(1)">
                            <v-icon color="primary">mdi-chevron-right</v-icon>
                        </v-btn>

                        <h3 class="ml-4 mb-0 calendar-month">{{ currentMonthName }} de {{ currentYear }}</h3>
                    </v-col>
                </v-row>

                <v-divider class="divider-blue mb-8"></v-divider>

                <v-row class="week-days text-center font-weight-bold mb-4" no-gutters>
                    <v-col v-for="(day, index) in weekDays" :key="index" class="py-2">
                        {{ day }}
                    </v-col>
                </v-row>

                <div class="days-grid">
                    <div v-for="(day, index) in monthDays" :key="index" class="day-box">
                        <div class="day-number" :class="{ 'day-today': isToday(day) }">
                            {{ day.getDate() }}
                        </div>

                        <div class="day-event" v-if="hasAssembly(day)">
                            <v-btn class="btn-gradient" small block @click="openAssemblyDialog(getAssembly(day))">
                                {{ getAssemblyName(day) }}
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- MODAL -->
        <v-dialog v-model="showAssemblyDialog" max-width="600px">
            <v-card class="pa-6">

                <h2 class="assembly-title mb-4">
                    {{ selectedAssembly && selectedAssembly.name }}
                </h2>

                <div style="width: 100%; height: 3px; background-color: var(--v-primary-base);" class="mb-5"></div>

                <p class="assembly-text mb-2">
                    <strong class="primary--text" style="font-size: 18px;">
                        Data:
                    </strong>
                    <span class="primary--text" style="font-size: 18px; font-weight: bold;">
                        {{ selectedAssembly ? formatBR(selectedAssembly.start) : "" }}
                        –
                        {{ selectedAssembly ? formatBR(selectedAssembly.end) : "" }}
                    </span>

                </p>

                <p class="assembly-text">
                    <strong class="primary--text">Descrição:</strong><br />

                    <span v-html="selectedAssembly && selectedAssembly.description"></span>
                </p>

                <div class="d-flex justify-end mt-6">
                    <v-btn text color="grey" @click="closeAssemblyDialog">
                        Fechar
                    </v-btn>
                </div>

            </v-card>
        </v-dialog>

    </div>
</template>
<script>
export default {
    data() {
        return {
            currentDate: new Date(),
            currentMonth: new Date().getMonth(),
            currentYear: new Date().getFullYear(),
            viewMode: "Mês",

            assemblies: [
                {
                    name: "Credenciamento",
                    start: "2025-12-01",
                    end: "2025-12-10",
                    description:
                        "Prazo para realização do credenciamento pelos credores e representantes processuais na plataforma da Administração Judicial <a href='https://rj123milhas.com.br/' target='_blank'>rj123milhas.com.br</a>."
                },

                {
                    name: "Análise",
                    start: "2025-12-11",
                    end: "2025-12-20",
                    description:
                        "Prazo da Administração Judicial destinado à análise e apontamentos sobre eventuais inconsistências constantes dos instrumentos de procuração."
                },

                {
                    name: "Complementação",
                    start: "2025-12-22",
                    end: "2026-01-04",
                    description:
                        "Prazo para complementação documental pelos representantes dos credores. </br> <strong> *Aplicada a suspensão do período do dia 24/12/2025 a 01/01/2026, em razão das festas de final de ano, retomando a contagem, em dias corridos, em 02/01/2026.* </strong>"
                },

                {
                    name: "Validação",
                    start: "2026-01-05",
                    end: "2026-01-09",
                    description:
                        "Prazo da Administração Judicial para validação final da documentação complementar apresentada pelos credores"
                },

                {
                    name: "Revisão de Crédito",
                    start: "2026-01-12",
                    end: "2026-01-31",
                    description:
                        "Prazo dos Credores para preenchimento os formulários de revisão de crédito disponibilizados pela Administração Judicial <a href='https://rj123milhas.com.br/' target='_blank'>rj123milhas.com.br</a>. O prazo se iniciará após esgotada a fase de cadastramento de credores e seus representantes. "
                },

                {
                    name: "Recuperandas",
                    start: "2026-02-02",
                    end: "2026-02-21",
                    description:
                        "Prazo destinado às Recuperandas para responderem os Relatórios preenchidos pelos credores."
                },

                {
                    name: "Resposta Credor",
                    start: "2026-02-23",
                    end: "2026-02-27",
                    description: "Prazo dos credores sobre a proposta apresentada pelas Recuperandas."
                },

                {
                    name: "Análise",
                    start: "2026-03-02",
                    end: "2026-03-21",
                    description:
                        "Prazo da Administração Judicial para análise das Informações apresentadas pelos credores e Recuperandas."
                },
            ],

            weekDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],

            showAssemblyDialog: false,
            selectedAssembly: null,
        };
    },

    computed: {
        currentMonthName() {
            const months = [
                "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
            ];
            return months[this.currentMonth];
        },

        monthDays() {
            const firstDay = new Date(this.currentYear, this.currentMonth, 1);
            const lastDay = new Date(this.currentYear, this.currentMonth + 1, 0);
            const startWeek = firstDay.getDay();
            const totalDays = lastDay.getDate();
            const days = [];

            for (let i = 0; i < startWeek; i++) {
                days.push(new Date(this.currentYear, this.currentMonth, i - startWeek + 1));
            }

            for (let d = 1; d <= totalDays; d++) {
                days.push(new Date(this.currentYear, this.currentMonth, d));
            }

            while (days.length < 35) {
                days.push(
                    new Date(this.currentYear, this.currentMonth, totalDays + (days.length - startWeek - totalDays) + 1)
                );
            }

            return days;
        },
    },

    methods: {

        formatBR(dateStr) {
            const [year, month, day] = dateStr.split("-");
            return `${day}/${month}/${year}`;
        },

        formatDate(date) {
            return date.toISOString().split("T")[0];
        },

        changeMonth(direction) {
            this.currentMonth += direction;
            if (this.currentMonth < 0) {
                this.currentMonth = 11;
                this.currentYear--;
            } else if (this.currentMonth > 11) {
                this.currentMonth = 0;
                this.currentYear++;
            }
        },

        goToday() {
            const today = new Date();
            this.currentMonth = today.getMonth();
            this.currentYear = today.getFullYear();
        },

        hasAssembly(day) {
            const d = this.formatDate(day);
            return this.assemblies.some(a => d >= a.start && d <= a.end);
        },

        getAssembly(day) {
            const d = this.formatDate(day);
            return this.assemblies.find(a => d >= a.start && d <= a.end) || null;
        },

        getAssemblyName(day) {
            const a = this.getAssembly(day);
            return a ? a.name : "";
        },

        isToday(day) {
            const today = new Date();
            return (
                day.getDate() === today.getDate() &&
                day.getMonth() === today.getMonth() &&
                day.getFullYear() === today.getFullYear()
            );
        },

        openAssemblyDialog(assembly) {
            this.selectedAssembly = assembly;
            this.showAssemblyDialog = true;
        },

        closeAssemblyDialog() {
            this.showAssemblyDialog = false;
            this.selectedAssembly = null;
        },
    }
};
</script>

<style scoped>
.calendar-section {
    padding: 40px 0;
}

.calendar-title {
    color: var(--v-primary-base);
}

.calendar-section .divider-blue {
    height: 10px;
    background: var(--v-primary-base);

    border-radius: 4px;
    opacity: 0.9;
}

.calendar-section .days-grid {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 5px;
    width: 100%;
    max-width: 100%;
}

.calendar-section .day-box {
    background-color: #EFEFEF;
    border-radius: 8px;
    width: 100%;
    min-width: 0;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.calendar-section .day-number {
    font-weight: 700;
    font-size: 1.1rem;
    color: var(--v-primary-base);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.calendar-section .day-today {
    background-color: #D9E6F2;
    border: 1px solid var(--v-primary-base);
}

.calendar-section .btn-gradient {
    background: linear-gradient(to right, #2b3985, #3A5A8F);
    color: #ECECEC !important;
    font-size: 0.8rem;
    border-radius: 6px;
    text-transform: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
}

.assembly-title {
    font-size: 22px;
    font-weight: 700;
    text-align: left;
    color: var(--v-primary-base);
}

.assembly-text {
    font-size: 16px;
    line-height: 1.6;
}

@media (max-width: 600px) {
    .calendar-section {
        padding: 32px 0;
    }

    .calendar-section .days-grid {
        gap: 3px;
    }

    .calendar-section .day-box {
        height: 74px;
        padding: 6px 3px;
        border-radius: 6px;
    }

    .calendar-section .day-number {
        width: 28px;
        height: 28px;
        font-size: 0.9rem;
    }

    .calendar-section .btn-gradient {
        min-width: 0 !important;
        padding: 0 3px !important;
        font-size: 0.65rem;
    }
}
</style>
